@if(profile() === null || profile() === undefined)
{
    
    <div class="empty">
        <p>no details</p>
    </div>
}@else {

<div class="header">
    <img src="/profile-pic.jpg" [alt]="this.profile()!.lastName" />
    <div class="spacer"></div>
    <div>
        <h1>
            {{this.profile()!.firstName}}
            {{this.profile()!.lastName}}
            ({{this.profile()!.ceRMitId}})
            <a mat-button [href]="cermitLink()">
                <img src="/CeRMit-Icon-200.png" width="30px" alt="CeRMit Logo"/>
            </a>
        </h1>
        <p>
            @if(attachments() !== undefined
            && attachments() !== null
            && attachments()!.length > 0) {
                @for (attachment of attachments(); track $index) {
                    <button mat-flat-button (click)="this.downloadAttachment(attachment)">
                        <mat-icon>download</mat-icon>
                        {{attachment.originalFileName}}
                    </button>
                }
            }
        </p>
    </div>
</div>
<div class="body">

    @if(resumeLanguages() !== undefined
    && resumeLanguages()!.length > 0)
    {
    <div>
        <h1>Sprachkenntnisse</h1>
        @for (lang of resumeLanguages(); track $index) {
        {{lang.name}} ({{LanguageLevel[lang.level]}})
        }
    </div>
    }

    @if(resumeGraduations() !== undefined
    && resumeGraduations()!.length > 0)
    {
    <div>
        <h1>Graduations</h1>
        @for (graduation of resumeGraduations(); track $index) {

        <div class="divider"></div>
        <h2>
            @if(graduation.date !== null)
            {
                {{graduation.date | date: 'MM.yyyy'}}
                |
            }
            {{GraduationType[graduation.type]}}
            -
            {{graduation.title}}
            @if(graduation.issuer !== null)
            {
            |
                {{graduation.issuer}}
            }
        </h2>
        }
    </div>
    }

    @if(resumeRoles() !== undefined
    && resumeRoles()!.length > 0)
    {
    <div>
        <h1>Roles</h1>
        {{resumeRoles().join(', ')}}
    </div>
    }

    @if(resumeSkills() !== undefined
    && resumeSkills()!.length > 0)
    {
    <div>
        <h1>Skills</h1>
        <app-chip-list [list]="resumeSkills()" />
    </div>
    }

    @if(resumeAchievements() !== undefined
    && resumeAchievements()!.length > 0)
    {
    <div>
        <h1>Achievements</h1>
        @for (achievement of resumeAchievements(); track $index) {

        <div class="divider"></div>
        <h2>
            @if(achievement.date !== null)
            {
                {{achievement.date | date: 'MM.yyyy'}}
                |
            }
            {{achievement.title}}
        </h2>
        <p>{{achievement.issuer}}</p>
        <app-chip-list [list]="achievement.skills ?? []" />
        }
    </div>
    }

    @if(resumeProjects() !== undefined
    && resumeProjects()!.length > 0)
    {
    <div>
        <h1>Projects</h1>
        @for (project of resumeProjects(); track $index) {

        <div class="divider"></div>
        <h2>
            {{project.start | date: 'MM.yyyy'}}-{{project.end | date: 'MM.yyyy'}}
            |
            {{project.industry}}
            -
            {{project.roles?.join(', ')}}
        </h2>
        <p>{{project.name}}</p>
        <app-chip-list [list]="project.skills ?? []" />
        }
    </div>
    }
</div>

}